module.exports = __webpack_public_path__ + "img/regular-unlink.e85331e9.svg";